// extracted by mini-css-extract-plugin
module.exports = {"wrap":"pl","articleImagesWrap":"ql","articleImage":"rl","singleImage":"sl"};